export function Contact(){
        return (
            <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
                <h2>Contact Us</h2>
                <p>We are a group of mountain bike enthusiasts. Please feel free to contact us should you have any questions, comments, or suggestions. We are always looking for ways to improve our services and provide the best experience for our customers. You can reach us through the following channels:</p>
                <p>Email: contact@mtb.cr</p>
            </div>
        );
}


